import { logger } from '../Api';

export enum CardType {
  ChartAdd = 'chartadd',
  PlaylistAdd = 'playlistadd',
}

export type HomeCardImpressionEvent = {
  card_id: string;
  card_type: CardType;
  network_id: string | null;
};

export type HomeCardInteractionEvent = {
  card_id: string;
  card_type: CardType;
  network_id: string | null;
  show_uri: string;
  destination_url: string;
};

export type HomeTracker = {
  makeHomeCardInteractionEvent: (
    cardId: string,
    cardType: CardType,
    networkId: string | null,
    showId: string,
    destinationUrl: string,
  ) => HomeCardInteractionEvent;
  makeHomeCardImpressionEvent: (
    card_id: string,
    card_type: CardType,
    network_id: string | null,
  ) => HomeCardImpressionEvent;
  trackImpression: (event: HomeCardImpressionEvent) => void;
  trackInteraction: (event: HomeCardInteractionEvent) => void;
  trackChartShareCardDownload: (event: HomeCardInteractionEvent) => void;
};

export const useHomeTracker = (): HomeTracker => {
  return {
    makeHomeCardImpressionEvent: (cardId, cardType, networkId) => ({
      card_id: cardId,
      card_type: cardType,
      network_id: networkId,
    }),
    makeHomeCardInteractionEvent: (cardId, cardType, networkId, showId, destinationUrl) => ({
      card_id: cardId,
      card_type: cardType,
      network_id: networkId,
      show_uri: `spotify:show:${showId}`,
      destination_url: destinationUrl,
    }),
    trackImpression: event => logger.logHomeCardImpression(event),
    trackInteraction: event => logger.logHomeCardInteraction(event),
    trackChartShareCardDownload: event => logger.logChartShareCardDownload(event),
  };
};
